import React, { useState, Component, useEffect } from "react";
import ICONS from "../../../../../icons-lib";
import "./card.scss";

const Card = (props) => {
  const [teacherModal, setTeacherModal] = useState(false);

  const TeacherBlock = (props) => {
    const [teacherSelect, setTeacherSelect] = useState(false);

    return(
      <>
      <div className={"teacher " + (teacherSelect ? "selected" : "")} onClick={(e)=>setTeacherSelect(!teacherSelect)}>
        <div className="left">
          <div className="icon">{ICONS.SVG_teacher}</div>
          <div className="name">Mr. John Doe</div>
        </div>

        <div className="buttons flex items-center justify-end">
          { props.started ? 
            <div className="progress grid gap-4 w-1/2 mr-3">
              <div className="track rounded-full">
                <span class="complete" style={{"--complete-percent": "70%"}}></span>
              </div>
              <span className="percent">70%</span>
            </div>
          : "" }

          <div className="button fancy">
            <span>{ props.started ? "Continue" : "Start survey"}</span>
            {ICONS.SVG_Arrow_curly}
          </div>
        </div>
      </div>
      </>
    );
  }

  switch (props.style) {
    case "1":
      return (
        <>
          <div className="card card-style-1 p-4 cursor-pointer duration-200 rounded-lg relative top-0 left-0 hover:-top-2">
            <div className="inner grid gap-4 items-center">
              <div className="left image-wrapper rounded-lg overflow-hidden h-48 w-full">
                <img src="https://source.unsplash.com/random/300x200" alt="" className="w-full h-full object-cover" />
              </div>

              <div className="right text-left">
                <div className="title font-semibold text-size-heading-small text-heading duration-200">Student satisfaction survey</div>
                <div className="desc text-size-body my-4">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis tenetur dolorem culpa veniam quaerat nam mollitia labore vitae soluta eaque.</div>
                <div className="posted-on text-size-body-small my-4 opacity-50">Posted on: 5th January, 2023</div>

                <div className="buttons text-right">
                  <div className="button fancy">
                    <span>Take survey</span>
                    {ICONS.SVG_Arrow_curly}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      );
      

    case "2":
      return (
        <>
          <div className={"modal select-teacher-modal " + (teacherModal ? "show" : "")}>
            <div className="modal-inner">
              <div
                className="close-modal cursor-pointer flex justify-end"
                onClick={(e)=>setTeacherModal(false)}>{ICONS.SVG_close}</div>
              <div class="title font-heading text-3xl mb-3">Please select a Teacher</div>

              <div className="teacher-list">
                <TeacherBlock />
                <TeacherBlock />
                <TeacherBlock started={true} />
                <TeacherBlock />
                <TeacherBlock />
                <TeacherBlock />
                <TeacherBlock />
                <TeacherBlock />
              </div>
            </div>
          </div>


          <div className="card card-style-2 p-4 cursor-pointer duration-200 rounded-lg relative top-0 left-0 hover:-top-2">
            <div className="inner gap-4 items-center">
              <div className="left image-wrapper rounded-lg overflow-hidden h-64 w-full">
                <img src="https://source.unsplash.com/random/300x200" alt="" className="w-full h-full object-cover" />
              </div>

              <div className="right text-left">
                <div className="title font-semibold text-size-heading-small text-heading my-4 duration-200">Student satisfaction survey</div>
                <div className="desc text-size-body my-4">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis tenetur dolorem culpa veniam quaerat nam mollitia labore vitae soluta eaque.</div>
                <div className="posted-on text-size-body-small my-4 opacity-50">Posted on: 5th January, 2023</div>

                <div className="buttons text-right">
                  <div className="button fancy" onClick={(e)=>setTeacherModal(true)}>
                    <span>Take survey</span>
                    {ICONS.SVG_Arrow_curly}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      );


    case "3":
      return (
        <>
          <div className="card card-style-3 p-4 cursor-pointer duration-200 rounded-lg relative top-0 left-0 hover:-top-2">
            <div className="inner gap-4 items-center">
              <div className="left image-wrapper rounded-lg overflow-hidden h-64 w-full">
                <img src="https://source.unsplash.com/random/300x200" alt="" className="w-full h-full object-cover" />
              </div>

              <div className="right text-left">
                <div className="title font-semibold text-size-heading-small text-heading my-4 duration-200">Student satisfaction survey</div>
                <div className="desc text-size-body my-4">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis tenetur dolorem culpa veniam quaerat nam mollitia labore vitae soluta eaque.</div>
                <div className="posted-on text-size-body-small my-4 opacity-50 flex items-center justify-between">
                  <span>Posted on: 5th January, 2023</span>
                  <span>Started on: 5th January, 2023</span>
                </div>

                <div className="buttons grid gap-8 items-center justify-between">
                  <div className="progress grid gap-4">
                    <div className="track rounded-full">
                      <span class="complete" style={{"--complete-percent": "70%"}}></span>
                    </div>
                    <span className="percent">70%</span>
                  </div>


                  <div className="button fancy">
                    <span>Continue survey</span>
                    {ICONS.SVG_Arrow_curly}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      );
      
  
    default:
      break;
  }
};

export default Card;